import { Injectable, Signal, signal } from '@angular/core'
import { APP_CONFIG } from '@isl-core/constants/app.constant'

@Injectable({
    providedIn: 'root'
})
export class CityService {
    private _city = signal<string>(APP_CONFIG.cityDefault)

    public get(): Signal<string> {
        return this._city
    }

    public set(value: string): void {
        this._city.set(value)
    }
}
